module.exports = ".wrapper{background-color:#fff;box-shadow:0 4px 0 0 rgba(0,0,0,.15);border:solid 1px #ccc;min-width:320px}"